import { Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateProjectMutation,
  useUpdateIntegrationMutation,
} from "../../../redux/slices/projectApiSlice";
import { trackPlatformUsed } from "../../../components/trackers";
import { platforms } from "../helper";
import {
  ShopifyIntegrationForm,
  WixIntegrationForm,
  WordpressIntegrationForm,
} from "../platforms";

const ProjectIntegrationForm = ({
  platform_name,
  project = null,
  setProject = null,
  integrationData = null,
  onCloseDialog = null, 
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [createProject, { isLoading: createLoading }] =
    useCreateProjectMutation();
  const [updateIntegration, { isLoading: updateLoading }] =
    useUpdateIntegrationMutation();

  const platform = platforms.find(
    (p) => p.name.toLowerCase() === platform_name?.toLowerCase()
  );

  const [open, setOpen] = useState(integrationData?.seo_plugin ? false : true);

  return (
    <Formik
      initialValues={
        project && integrationData
          ? integrationData
          : platform.integrationInitialValues
      }
      validationSchema={platform.integrationValidationSchema}
      enableReinitialize={true}
      onSubmit={async (values) => {
        try {
          if (project) {
            //  Update existing integration
            trackPlatformUsed("project", "update_integration");

            
            let integrationPayload = {
  url: values.url,
  username: values.username,
  password: values.password,
  version: "6.0",
};

// Include WordPress SEO plugin data if platform is WordPress
if (platform_name.toLowerCase() === "wordpress") {
  integrationPayload = {
    ...integrationPayload,
    access_token: values.access_token || null,
    seo_plugin: values.seo_plugin || null,
    meta_title_field_name: values.meta_title_field_name || null,
    meta_description_field_name: values.meta_description_field_name || null,
    target_request_field_name: values.target_request_field_name || null,
    api_key: values.api_key || null,
    account_id: values.account_id || null,
    site_id: values.site_id || null,
  };
}
const res = await updateIntegration({
  platform: platform.name.toLowerCase(),
  integration_data: integrationPayload,
  id: project.id,
}).unwrap();


            toast.success(
              t(
                "modified-project-integration",
                "L'intégration du site web a bien été modifiée !"
              )
            );

            //  Update local project state
            const updatedProject = {
              ...res.data,
              integration_data: {
                ...res.data.integration_data,
                _updatedAt: new Date().toISOString(),
              },
              _updatedAt: new Date().toISOString(),
            };
            if (setProject) setProject(updatedProject);

            // Close SEO modal (WordPress)
            if (platform_name.toLowerCase() === "wordpress" && open) {
              setOpen(false);
            }

            //  Close parent dialog after successful integration
            if (onCloseDialog) await onCloseDialog();
          } else {
            // Create new project integration
            trackPlatformUsed("project", "integrate");

            const res = await createProject({
              platform: platform.name,
              integration_data: values,
            }).unwrap();

            toast.success(
              t("created-project", "Le site web a bien été lié !")
            );

            // Navigate after creation
            if (res.status === 201) {
              if (platform_name.toLowerCase() === "wordpress") {
                navigate(`/project/${res.data.id}?finalize=true`);
              } else {
                navigate(`/project/${res.data.id}`);
              }
            }

            //  Close parent dialog after success
            if (onCloseDialog) await onCloseDialog();
          }
        } catch (error) {
          toast.error(
            t(
              "error-linking-project",
              "Une erreur a eu lieu lors de l'intégration du site web !"
            )
          );
        }
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} method="POST">
          {platform?.name === "WordPress" ? (
            <WordpressIntegrationForm
              props={props}
              createLoading={createLoading || updateLoading}
              platform={platform}
              project={project}
              open={open}
              setOpen={setOpen}
            />
          ) : platform?.name === "Shopify" ? (
            <ShopifyIntegrationForm
              props={props}
              createLoading={createLoading || updateLoading}
              platform={platform}
              project={project}
            />
          ) : (
            platform?.name === "Wix" && (
              <WixIntegrationForm
                props={props}
                createLoading={createLoading || updateLoading}
                platform={platform}
                project={project}
              />
            )
          )}
        </form>
      )}
    </Formik>
  );
};

export default ProjectIntegrationForm;
